export const YEAR_CONTENT_SLIDER_PROPS = {
  slidesToShow: 1,
  slidesPerRow: 1,
  swipe: true,
  slidesToScroll: 1,
  arrows: true,
  dots : false,
  speed: 300,
  fade: true,
  draggable: true,
  infinite: true,
};

export const TIMELINE_SLIDER_PROPS = {
  dots: false,
  infinite: false,
  speed: 300,
  swipe: true,
  slidesPerRow: 1,
  slidesToShow: 5,
  slidesToScroll: 1,
  variableWidth: false,
  draggable: true,
  infinite: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 4
      },
    },
  ],
};
